import { makeStyles } from "@fluentui/react-components";

export const getCopilotChatDrawerStyles: () => Record<"copilotPane" | "overrideFuiIconFont", string> = makeStyles({
    copilotPane: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        position: "relative",
    },
    overrideFuiIconFont: {
        "& .fui-Icon-font": {
            fontWeight: "500", // Overrides the semibold default for Fluent UI Icon Fonts
        },
    },
});
